// name Color
export const PURPLE = "purple";
export const BLUE = "blue";
export const GREEN = "green";
export const RED = "red";
export const ORANGE = "orange";
export const ROSE = "rose";

// colors Template
export const PRIMARY = "primary";
export const INFO = "info";
export const SUCCESS = "success";
export const WARNING = "warning";
export const DANGER = "danger";

// colors rgb
export const PURPLE_RGB = "#9c27b0";
export const BLUE_RGB = "#004F9F";
export const BLUE_SECONDARY_RGB = "#0055aa";
export const BLUE_LIGHT_RGB = "#00BCD4";
export const GREEN_RGB = "#4caf50";
export const RED_RGB = "#f44336";
export const RED_STRONG_RGB = "#A32C24";
export const ORANGE_RGB = "#ff9800";
export const ROSE_RGB = "#e91e63";
